export const issueRaisedWindowText = {
  shipment: `Go to the shipment details page to raise an issue. Click on the tracking id on the listing page to view the shipment details page`,
  default: `Go to the trip details page to raise an issue. Click on reference number/trip id on the listing page to view trip details page`
}
